export default __webpack_public_path__ + "static/media/q24_step5.dae34c60.png";